import { TenantNotification } from '../../../../../../backend-core-lib/app/common-shared/account/models';

export function getNotificationIcon(
  tenantNotification: TenantNotification,
): string {
  switch (tenantNotification.notificationType) {
    case 'warning':
      return 'pi pi-exclamation-triangle text-orange-70';
    case 'error':
      return 'pi pi-exclamation-triangle text-red-700';
    case 'info':
      return 'pi pi-info-circle text-blue-700 ';
  }
}
